module.exports = __webpack_public_path__ + "static/freelancer-illustration-0df4e879166dad8e56d69410f728c5a8.svg";